// Mixin for checking expiration date, and set counter
import { mapGetters, mapState, mapActions } from "vuex";
import StructCaller from "@/helpers/structInterface";
import countdown from "countdown";

export default {
  data() {
    return {
      timer: null,
      showExpiration: false,
      expires: null,
      expiresDate: null,
      StructCaller,
    };
  },
  computed: {
    ...mapState(["invoiceInitialData"]),
  },
  methods: {
    ...mapActions("UI", ["ADD_MESSAGE"]),
    ...mapActions(["setGlobalError"]),

    validateDate() {
      const now = new Date();
      // IF unix timestamp, we need * on 1000;

      const passedExpirationDate = new Date(
        this.invoiceInitialData.expires * 1000
      );
      this.expiresDate = passedExpirationDate;

      // Check that the date passed from query is valid
      if (
        Object.prototype.toString.call(passedExpirationDate) === "[object Date]"
      ) {
        if (isNaN(passedExpirationDate.getTime())) {
          //  Date is Invalid 👎
          return Promise.reject(
            this.StructCaller.getStructData("ERRORS", "code", "invalid_date")
          );
        } else {
          const expired = this.checkExpirationDate(this.expiresDate);

          if (expired) {
            // Already expired 👎
            return Promise.reject(
              this.StructCaller.getStructData("ERRORS", "code", "invalid_date")
            );
          } else {
            // Valid 👍
            return Promise.resolve({
              type: "success",
              isValid: true,
            });
          }
        }
      } else {
        // Not a date at all.
        return Promise.reject(
          this.StructCaller.getStructData("ERRORS", "code", "invalid_date")
        );
      }
    },

    /**
     *  Check that data doesn't expired yet
     */
    checkExpirationDate(expirationDate) {
      const now = new Date();
      const expires = now - expirationDate >= 0;
      return expires;
    },

    countDown() {
      const expired = this.checkExpirationDate(this.expiresDate);
      if (!expired) {
        this.expires = countdown(
          new Date(),
          this.expiresDate,
          countdown.HOURS | countdown.MINUTES | countdown.SECONDS
        ).toString();
      } else {
        clearInterval(this.timer);
        this.setGlobalError({
          code: "date_expired",
        });
      }
    },
  },
};
